query WfaUsageData(
	$daysAmountFilter: ConditionInt
	$daysAmountx2Filter: ConditionInt
	$textSearch: wfa_session_runsSearchInsensitive
	$textSearchPages: pagesSearchInsensitive
	$createdByFilter: ConditionString
	$customFieldsFilter: ConditionStringArray
) {
	last_n_days: wfa_session_runs(
		run_time_last_n_days: $daysAmountFilter
		text_contains: $textSearch
		user_name_eq: $createdByFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
	) {
		run_id_count
		total_pages_sum
		user_name_group_uniq_array
	}
	last_2n_days: wfa_session_runs(
		run_time_last_n_days: $daysAmountx2Filter
		text_contains: $textSearch
		user_name_eq: $createdByFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
	) {
		run_id_count
		total_pages_sum
		user_name_group_uniq_array
	}
	last_n_days_urls: pages(
		run_time_last_n_days: $daysAmountFilter
		product_name_eq: { value: "WEB_FLOW_ANALYZER" }
		text_contains: $textSearchPages
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
	) {
		url_group_uniq_array
	}
	last_2n_days_urls: pages(
		run_time_last_n_days: $daysAmountx2Filter
		product_name_eq: { value: "WEB_FLOW_ANALYZER" }
		text_contains: $textSearchPages
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
	) {
		url_group_uniq_array
	}
}
